import { render, staticRenderFns } from "./UserActionsFour.vue?vue&type=template&id=dddecdc2&scoped=true"
import script from "./UserActionsFour.vue?vue&type=script&lang=js"
export * from "./UserActionsFour.vue?vue&type=script&lang=js"
import style0 from "./UserActionsFour.vue?vue&type=style&index=0&id=dddecdc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddecdc2",
  null
  
)

export default component.exports